module.exports = __webpack_public_path__ + "static/thumb-4-a0a6021d99dd4aaf219f9e0fb8520fb0.jpg";